import { Box } from '@mui/material'
import colors from '../../constants/colors'
import { IBasicContainer } from './types'

const basicContainerStyle = {
  py: '2.2rem',
  px: '3.6rem',
  backgroundColor: colors.WHITE,
  border: '1px solid',
}

const BasicContainer: React.FC<IBasicContainer> = ({ children, type = 'normal' }) => {
  return (
    <Box
      sx={{
        ...basicContainerStyle,
        borderColor: type === 'error' ? colors.TAG_RED : colors.TAG_BORDER_BLUE,
      }}
    >
      {children}
    </Box>
  )
}

export default BasicContainer
